import React from 'react';
import './sharedProperty info.css'
import { MDBContainer, MDBRow, MDBCol, MDBBtn, MDBIcon } from "mdbreact";
import "react-image-gallery/styles/css/image-gallery.css";
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import allStrings from "../../assets/strings";
import { connect } from "react-redux";
import { withRouter, Redirect } from "react-router-dom";
import { BASE_END_POINT } from "../../urls";
import axios from "axios";
import { message, Spin, TreeSelect, Image, Popconfirm } from "antd";
import { UploadOutlined } from '@ant-design/icons';
import Tooltip from '@material-ui/core/Tooltip';

const { TreeNode } = TreeSelect;
const { SHOW_PARENT } = TreeSelect;
class sharedPropertyInfo extends React.Component {
  state = {
    actionType: this.props.location.state.actionType ? this.props.location.state.actionType === "EDIT" ? "EDIT" : "VIEW" : "VIEW",
    id: this.props.location.state.data.id,
    finishingType: this.props.location.state.data.finishingType ? this.props.location.state.data.finishingType : ['FULLY-FINISHED'],
    deliveryStatus: this.props.location.state.data.deliveryStatus ? this.props.location.state.data.deliveryStatus : ['READY-TO-MOVE'],
    priceType: this.props.location.state.data.priceType ? this.props.location.state.data.priceType : 'INSTALLMENT',
    sharePrice: this.props.location.state.data.sharePrice ? this.props.location.state.data.sharePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')  : 0,
    price: this.props.location.state.data.price ? this.props.location.state.data.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
    downPayment: this.props.location.state.data.downPayment ? this.props.location.state.data.downPayment : 0,
    durationType: this.props.location.state.data.durationType ? this.props.location.state.data.durationType : 'MONTHLY',
    installmentDuration: this.props.location.state.data.installmentDuration ? this.props.location.state.data.installmentDuration : 0,
    monthlyInstallment: this.props.location.state.data.monthlyInstallment ? this.props.location.state.data.monthlyInstallment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','):0,
    projectName_ar: this.props.location.state.data.projectName_ar ? this.props.location.state.data.projectName_ar : "",
    projectName_en: this.props.location.state.data.projectName_en ? this.props.location.state.data.projectName_en : "",
    category: this.props.location.state.data.category ? this.props.location.state.data.category.id : null,
    location: this.props.location.state.data.location ? this.props.location.state.data.location.id : null,
    totalShares: this.props.location.state.data.totalShares ? this.props.location.state.data.totalShares : 0,
    availableShares: this.props.location.state.data.availableShares ? this.props.location.state.data.availableShares : 0,
    soldShares: this.props.location.state.data.soldShares ? this.props.location.state.data.soldShares : 0,
  
    type: this.props.location.state.data.type,
    categories: [],
    locations: [],
    projectNames: [],
    imgs: this.props.location.state.data.imgs ? this.props.location.state.data.imgs : null,
    allImgs: this.props.location.state.data.imgs ? this.props.location.state.data.imgs : [],
    imgsPreviewUrl: this.props.location.state.data.imgs ? this.props.location.state.data.imgs : [],
    imgsName: [],
    imgsType: 'url',
    voiceNote: this.props.location.state.data.voiceNote ? this.props.location.state.data.voiceNote : null,
    voiceNoteType: "url",
    companyLogo: this.props.location.state.data.companyLogo ? this.props.location.state.data.companyLogo : null,
    companyLogoType:'url',
    companyLogoName:'',
    employePhone: this.props.location.state.data.employePhone ? this.props.location.state.data.employePhone.replace("+2", "") : '',
    employeName: this.props.location.state.data.employeName ? this.props.location.state.data.employeName : '',
    employeCountry: this.props.location.state.data.employeCountry ? this.props.location.state.data.employeCountry.id : null,
    ratio: this.props.location.state.data.ratio ? this.props.location.state.data.ratio : 0,
    netRatio: this.props.location.state.data.netRatio ? this.props.location.state.data.netRatio : 0,
    minShares: this.props.location.state.data.minShares ? this.props.location.state.data.minShares : 1,
    loading: false,
    refresh: false,
    available: this.props.location.state.data.available,
    url:this.props.location.state.data.url,
    copyColor:'#333333',
    countries: [],
    pdf: this.props.location.state.data.pdf ? this.props.location.state.data.pdf : null,
    pdfType: 'url',
    pdfName:''


  };

  constructor(props) {
    super(props)
    window.scrollTo(0, 0)
    this.getData()
    this.getCategory()
    this.getLocations()
    this.getCountries()
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  componentDidMount() {
    if (this.props.isRTL) {
      allStrings.setLanguage('ar')
    } else {
      allStrings.setLanguage('en')
    }
  }
  getData = () => {
    axios.get(`${BASE_END_POINT}sharedProperties/${this.state.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      }
    })
      .then(response => {
        console.log('shared property  ', response.data.data)
        this.setState({
          loading: false,
          finishingType: response.data.data.finishingType ? response.data.data.finishingType : ['FULLY-FINISHED'],
          deliveryStatus: response.data.data.deliveryStatus ? response.data.data.deliveryStatus : ['READY-TO-MOVE'],
          priceType: response.data.data.priceType ? response.data.data.priceType : 'INSTALLMENT',
          sharePrice: response.data.data.sharePrice ? response.data.data.sharePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
          type: response.data.data.type,
          price: response.data.data.price ? response.data.data.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
          downPayment: response.data.data.downPayment ? response.data.data.downPayment : 0,
          durationType: response.data.data.durationType ? response.data.data.durationType : 'YEARLY',
          monthlyInstallment: response.data.data.monthlyInstallment ? response.data.data.monthlyInstallment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : 0,
          installmentDuration: response.data.data.installmentDuration,
          projectName_ar: response.data.data.projectName_ar ? response.data.data.projectName_ar : "",
          projectName_en: response.data.data.projectName_en ? response.data.data.projectName_en : "",
          category: response.data.data.category ? response.data.data.category.id : null,
          location: response.data.data.location ? response.data.data.location.id : null,
          imgs: response.data.data.imgs ? response.data.data.imgs : null,
          allImgs: response.data.data.imgs ? response.data.data.imgs : null,
          imgsPreviewUrl: response.data.data.imgs ? response.data.data.imgs : [],
          voiceNote: response.data.data.voiceNote ? response.data.data.voiceNote : null,
          totalShares: response.data.data.totalShares ? response.data.data.totalShares : 0,
          availableShares: response.data.data.availableShares ? response.data.data.availableShares : 0,
          soldShares: response.data.data.soldShares ? response.data.data.soldShares : 0,
          companyLogo: response.data.data.companyLogo ? response.data.data.companyLogo : null,
          employePhone: response.data.data.employePhone ? response.data.data.employePhone.replace("+2", "") : '',
          employeName: response.data.data.employeName ? response.data.data.employeName : '',
          employeCountry: response.data.data.employeCountry ? response.data.data.employeCountry.id : null,
          netRatio: response.data.data.netRatio ? response.data.data.netRatio : 0, 
          ratio: response.data.data.ratio ? response.data.data.ratio : 0,
          minShares: response.data.data.minShares ? response.data.data.minShares : 1,
          url: response.data.data.url ? response.data.data.url : null,
          pdf: response.data.data.pdf ? response.data.data.pdf : null
        })
      })
      .catch(error => {
        console.log('theUser ERROR  ', error)
        console.log('theUser ERROR  ', error.respose)
      })
  }
  getCategory = () => {
    axios.get(`${BASE_END_POINT}categories`)
      .then(response => {
        console.log(response.data)
        this.setState({ categories: response.data.data })
      })
      .catch(error => {
        console.log("ALL categories ERROR")
        console.log(error.response)
      })
  }
  getCountries = () => {
      axios.get(`${BASE_END_POINT}countries/withoutPagenation/get`,{
          headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${this.props.currentUser.token}`
          },
         })
      .then(response=>{
        console.log("countries",response.data)
        this.setState({countries:response.data.data})
      })
      .catch(error=>{
        console.log("ALL countries ERROR")
        console.log(error.response)
      })
    }
  getLocations = () => {
    axios.get(`${BASE_END_POINT}location/withoutPagenation/get`)
      .then(response => {
        console.log(response.data)
        this.setState({ locations: response.data.data })
      })
      .catch(error => {
        console.log("ALL locations ERROR")
        console.log(error.response)
      })
  }
  copyText = () => {
    this.setState({copyColor:'green'})
    this.refs.input.select();
    document.execCommand('copy');
    return false;
  }
  updateProperty = () => {
    const { finishingType, deliveryStatus, location, category, imgs, imgsType,companyLogo,
      minShares, employePhone, employeName, employeCountry, ratio, netRatio,companyLogoType,pdf,pdfType,
      projectName_ar,projectName_en, price, priceType, durationType, installmentDuration, downPayment,monthlyInstallment,
      totalShares, availableShares, soldShares,sharePrice, voiceNote, voiceNoteType } = this.state

    if (category !== null && location !== null && companyLogo !== null ) {
      let l = message.loading('Wait..', 2.5)
      var data = new FormData()
      data.append('finishingType', JSON.stringify(finishingType))
      data.append('deliveryStatus', JSON.stringify(deliveryStatus))
      data.append('projectName_ar',projectName_ar)
      data.append('projectName_en',projectName_en)
      data.append('minShares',minShares)
      data.append('employePhone',employePhone)
      data.append('employeName',employeName)
      data.append('employeCountry',employeCountry)
      data.append('ratio',ratio)
      data.append('netRatio',netRatio)
      data.append('price', price !=0 ? price.replace(/,/g, ''):0)
      data.append('priceType', priceType)
      data.append('category', category)
      data.append('location', location)
      data.append('sharePrice', sharePrice !=0 ? sharePrice.replace(/,/g, ''):0)
      data.append('type', 'RELATED-TO-COMPOUND')
      data.append('totalShares', totalShares)
      data.append('availableShares', availableShares)
      data.append('soldShares', soldShares)



      if (priceType === 'INSTALLMENT') {
        data.append('downPayment', downPayment !=0 ? downPayment.replace(/,/g, ''):0)
        data.append('durationType', durationType)
        data.append('installmentDuration', installmentDuration)
        data.append('monthlyInstallment', monthlyInstallment !=0? monthlyInstallment.replace(/,/g, '') : 0)
      }

      if (imgs != null && imgsType === "data") {
        for (var i = 0; i <= imgs.length - 1; i++) {
          data.append(`imgs`, imgs[i])
        }
      }
      if (companyLogo != null && companyLogoType === "data") {
        data.append(`companyLogo`, companyLogo)
      }
      if(pdf != null && pdfType ==="data"){
          data.append(`pdf`,pdf )
      }
      if (voiceNote != null && voiceNoteType === "data") {
        data.append(`voiceNote`, voiceNote)
      }
      if (voiceNote == null) {
        data.append(`emptyVoiceNote`, true)
      }
      

      console.log(Array.from(data))
      axios.put(`${BASE_END_POINT}sharedProperties/${this.props.location.state.data.id}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Authorization': `Bearer ${this.props.currentUser.token}`,
          'Accept-Language': this.props.isRTL ? 'ar' : 'en'
        },
      })
        .then(response => {
          console.log("USER UPDATED  ", response.data)
          l.then(() => message.success(allStrings.done, 2.5))
          this.props.history.goBack()
          // this.setState({actionType:'VIEW'})
          // this.getData()
          // window.scrollTo(0, 0)
        })
        .catch(error => {
          console.log(error.response)
          l.then(() => message.error(allStrings.error, 2.5))
        })
    }
  }

  delete = () => {
    let l = message.loading('Wait..', 2.5)
    axios.delete(`${BASE_END_POINT}sharedProperties/${this.props.location.state.data.id}`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        console.log("Row DELETED")
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log(error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  fileChangedHandler = (event) => {
    let imgs = [];
    let imgsPreviewUrl = [];
    let imgsName = []
    for (var i = 0; i <= event.target.files.length - 1; i++) {
      imgsPreviewUrl.push(URL.createObjectURL(event.target.files[i]))
      imgsName.push(event.target.files[i].name)
    }
    imgs.push(event.target.files)
    this.setState({
      imgs: event.target.files,
      imgsType: 'data',
      imgsPreviewUrl: imgsPreviewUrl,
      imgsName: imgsName
    });

  };
  removeFile = (url) => {
    let arr = this.state.imgsPreviewUrl;
    let arr2 = Array.from(this.state.imgs);
    var index = arr.indexOf(url);
    if (index !== -1) arr.splice(index, 1);
    if (index !== -1) arr2.splice(index, 1);
    this.setState({
      imgsPreviewUrl: arr,
      imgs: arr2,
    });
    if (arr2.length === 0) {
      this.setState({
        imgs: null,
      });
    }

  };
  fileChangedHandlerVoiceNote = event => {
    console.log(event.target.files[0])
    this.setState({
      voiceNote: event.target.files[0],
      voiceNoteType: "data"
    })
    document.addEventListener("DOMContentLoaded", function () {
      document.getElementById('audioFileInput').addEventListener('change', function (event) {
        var file = event.target.files[0];
        var audioPlayer = document.getElementById('audioPlayer');
        var audioSource = document.getElementById('audioSource');
        if (file) {
          audioSource.src = URL.createObjectURL(file);
          audioPlayer.load();
        }
      });
    });
  }
  removeFileVoiceNote = () => {
    this.setState({
      voiceNote: null,
      voiceNoteType: "url"
    });
  }
  fileChangedHandlerCompanyLogo = event => {
    this.setState({
      companyLogo: event.target.files[0],
      companyLogoName: event.target.files[0].name,
      companyLogoType:"data"
    })
    
  }
  removeFileCompanyLogo = () => {
    this.setState({
        companyLogo:null,
        companyLogoName:'',
        companyLogoType:"url"
    });
  }
  fileChangedHandlerPdf = event => {
      this.setState({
        pdf: event.target.files[0],
        pdfType:"data",
        pdfName:event.target.files[0].name,
      })
      
  }
  removePdf = () => {
      this.setState({
          pdf:null,
          pdfName:'',
          pdfType:"url"
      });
  }

  imageSection = () => (
    <MDBCol xl="4" lg="5" md="12" sm="12">
      <div className="infoCard" style={{ marginTop: '80px' }}>
        <div className="StoreSlider">
          <div style={{ height: '280px', overflow: 'hidden' }}>
            <Image.PreviewGroup >
              {this.state.allImgs.map((val, i) =>
                <Image placeholder={true} width="100%" height="100%" style={{ display: i === 0 ? "block" : "none", borderRadius: '6px' }} src={val} />
              )}
            </Image.PreviewGroup>
          </div>
        </div>
      </div>
    </MDBCol>
  )



  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
    this.updateProperty()
  };

  changeHandler = event => {
        const { name, value } = event.target;
        if (name === "price" || name === "downPayment" || name === "monthlyInstallment" || name === "sharePrice") {
            let cleaned = value.replace(/[^0-9.]/g, '');
            // Allow only the first dot for decimal
            const firstDotIndex = cleaned.indexOf('.');
            if (firstDotIndex !== -1) {
                // Split at the first dot
                const integerPart = cleaned.substring(0, firstDotIndex);
                const decimalPart = cleaned.substring(firstDotIndex + 1).replace(/\./g, ''); 
                // Add commas to the integer part
                const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                event.target.value = `${formattedInteger}.${decimalPart}`;
            } else {
                // No dot, just format as integer
                event.target.value = cleaned.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
            }
        }

        this.setState({ [name]: event.target.value });
    };
  available = (available) => {
    let uri = '';
    if (available) {
      uri = `${BASE_END_POINT}sharedProperties/${this.state.id}/available`
    } else {
      uri = `${BASE_END_POINT}sharedProperties/${this.state.id}/dis-available`
    }
    let l = message.loading('Wait..', 2.5)
    axios.put(uri, {}, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.props.currentUser.token}`,
        'Accept-Language': this.props.isRTL ? 'ar' : 'en'
      },
    })
      .then(response => {
        l.then(() => message.success(allStrings.done, 2.5))
        this.props.history.goBack()
      })
      .catch(error => {
        console.log('Error   ', error.response)
        l.then(() => message.error(allStrings.error, 2.5))
      })
  }
  


  render() {
    console.log('sharePrice', this.state.sharePrice)
    if (this.props.currentUser.user.type === "SUB-ADMIN" && !this.props.currentUser.user.permission.pages.includes('PROPERTIES')) return <Redirect to='/Home' />
    return (
      <div className="App">
        <Spin spinning={this.state.loading} tip={allStrings.loading} size="large" style={{ color: '#233b5b' }}>
          <MDBContainer>
            <MDBRow>
              <MDBCol xl={this.state.actionType === "VIEW" ? "8" : "12"} lg={this.state.actionType === "VIEW" ? "7" : "12"} md="12" sm="12">
                <div className="infoCard">
                  <Card className="editCard">
                    <CardMedia
                      style={{ height: "0px" }}
                    />
                    <CardHeader></CardHeader>
                    <div style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row', display: 'flex' }}>
                      <div className="topIcon">
                        <span className="material-icons" style={{ color: 'white', fontSize: 23 }}>location_city</span>
                      </div>
                      <div className="tableTitle" style={{
                        display: this.props.isRTL ? 'inline-block' : 'inline-block', marginTop: this.props.isRTL ? '-60px' : '-60px',
                        marginLeft: this.props.isRTL ? '0' : '0', marginRight: this.props.isRTL ? '0' : '0', position: 'relative'
                      }}>
                        <p>{this.state.actionType === "VIEW" ? allStrings.info : allStrings.edit}</p>
                      </div>
                    </div>
                    <CardContent style={{ minHeight: "390px", outline: 'none' }}>
                      <MDBContainer>
                        {this.state.actionType === "VIEW" && this.state.url &&
                        <div>
                          <span class="material-icons" 
                            onClick={ this.copyText } 
                            style={{cursor:'pointer',color:this.state.copyColor}}>
                            content_copy
                          </span>
                          <input
                              ref="input"
                              type="text"
                              defaultValue={this.state.url}
                              style={{ position: 'fixed', top: '-1000px' }} />
                        </div>
                        }
                        <MDBRow>
                          <MDBCol md="12">
                            <form
                              className="needs-validation"
                              onSubmit={this.submitHandler}
                              noValidate
                            >

                              <div className="grey-text">
                                {this.state.actionType === "VIEW" &&
                                  <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form8" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>#</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.id} type="text" id="form8" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form88" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.showInApp}</label>
                                        <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.available ? allStrings.yes : allStrings.no} type="text" id="form88" className="form-control" />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                
                                {this.state.actionType === "VIEW" &&
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.availableShares}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.availableShares} type="text" min={0} id="form34" name="availableShares" className="form-control" onChange={this.changeHandler} validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.soldShares}</label>
                                      <input disabled style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.soldShares} type="text" min={0} id="form34" name="soldShares" className="form-control" onChange={this.changeHandler} validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                }
                                <MDBRow style={{flexDirection:this.props.isRTL?'row':'row-reverse'}}>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="formn8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.ratio}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.ratio} type="number" min={0} id="formn8" className="form-control" name='ratio' onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div className="md-form">
                                            <label htmlFor="formn8" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.netRatio}</label>
                                            <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.netRatio} type="number" min={0} id="formn8" className="form-control" name='netRatio' onChange={this.changeHandler} required validate/>
                                            <div class="valid-feedback">{allStrings.correct}</div>
                                            <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form33" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.totalShares}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.totalShares} type="number" min={0} id="form33" name="totalShares" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.minShares}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.minShares} type="text" min={1} id="form34" name="minShares" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.sharePrice}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.sharePrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} type="text" min={0} id="form34" name="sharePrice" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.price}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} type="text" min={0} id="form34" name="price" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                        <label for="form65" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.englishProjectName}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) =>e.currentTarget.value = e.currentTarget.value.replace(/[^A-Za-z0-9-,.@%$#*&()_^&!\\/\s-_]/g,'') } style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.projectName_en} type="text" id="form645" name="projectName_en" class="form-control" onChange={this.changeHandler} required  validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                        <div class="md-form">
                                        <label for="form56" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.arabicProjectName}</label>
                                        <input disabled={this.state.actionType==="VIEW"?true:false} onInput={(e) => e.currentTarget.value = e.currentTarget.value.replace(/[^\u0600-\u06FF0-9#.,@%$_^*()\/\\ _-]+/g, '')} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} value={this.state.projectName_ar} type="text" id="form56" name="projectName_ar" class="form-control" onChange={this.changeHandler} required validate/>
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                        </div>
                                    </MDBCol>
                                </MDBRow>
                                <MDBRow  style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="12">
                                      <div className="md-form">
                                          <label htmlFor="form3" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.employeName}</label>
                                          <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.employeName} type="text" id="form3" name="employeName" className="form-control" onChange={this.changeHandler} required validate/>
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow style={{flexDirection:this.props.isRTL?'row-reverse':'row'}}>
                                  <MDBCol md="6">
                                      <label style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.country}</label>
                                      <TreeSelect
                                      value= {this.state.employeCountry}
                                      showSearch={true} 
                                      style={{ width: '100%' ,textAlign:this.props.isRTL?'right':'left',height:'35px',marginBottom:'1rem'}} 
                                      treeCheckable = {false}    
                                      disabled={this.state.actionType==="VIEW"?true:false}     
                                      treeNodeFilterProp="title"                      
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.country}
                                      showCheckedStrategy= {SHOW_PARENT}
                                      onChange={(value) => {
                                          this.setState({employeCountry:value});
                                          console.log(value)
                                      }} 
                                      
                                      >
                                          {this.state.countries.map(val=>(
                                              <TreeNode value={val.id} title={this.props.isRTL?val.name_ar:val.name_en} key={val.id} />
                                          ))}
                                      </TreeSelect>
                                  </MDBCol>
                                  <MDBCol md="6">
                                      <div className="md-form">
                                          <label htmlFor="form03" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.employePhone}</label>
                                          <input disabled={this.state.actionType==="VIEW"?true:false} style={{direction:this.props.isRTL?'rtl':'ltr',backgroundPosition: this.props.isRTL?'left calc(.375em + .1875rem) center':'right calc(.375em + .1875rem) center'}} defaultValue={this.state.employePhone} type="text" id="form03" name="employePhone" className="form-control" onChange={this.changeHandler} required validate/>
                                          <div class="valid-feedback">{allStrings.correct}</div>
                                          <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                  </MDBCol>
                                </MDBRow>
                                
                                <MDBRow>
                                  <MDBCol md="6" sm="6">
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.location}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      disabled={this.state.actionType === "EDIT" ? false : true}
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.location}
                                      value={this.state.location}
                                      showCheckedStrategy={SHOW_PARENT}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ location: value });
                                      }}

                                    >
                                      {this.state.locations.map(val => (
                                        <TreeNode value={val.id} title={this.props.isRTL ? val.name_ar : val.name_en} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                  <MDBCol md="6" sm="6">
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.category}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={false}
                                      disabled={this.state.actionType === "EDIT" ? false : true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.category}
                                      value={this.state.category}
                                      showCheckedStrategy={SHOW_PARENT}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ category: value });
                                      }}

                                    >
                                      {this.state.categories.map(val => (
                                        <TreeNode value={val.id} title={this.props.isRTL ? val.categoryName_ar : val.categoryName_en} key={val.id} />
                                      ))}
                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row-reverse' : 'row' }}>
                                  <MDBCol md="6" sm="6">
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.deliveryStatus}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={false}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                      treeCheckable={true}
                                      treeNodeFilterProp="title"
                                      disabled={this.state.actionType === "EDIT" ? false : true}
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.deliveryStatus}
                                      value={this.state.deliveryStatus}
                                      showCheckedStrategy={SHOW_PARENT}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ deliveryStatus: value });
                                      }}

                                    >
                                      <TreeNode value="READY-To-MOVE" title={allStrings.readyToMove} key="READY-To-MOVE" />
                                      <TreeNode value="AFTER-ONE-YEAR" title={allStrings.afterOneYears} key="AFTER-ONE-YEAR" />
                                      <TreeNode value="AFTER-TWO-YEARS" title={allStrings.afterTwoYears} key="AFTER-TWO-YEARS" />
                                      <TreeNode value="AFTER-THREE-YEARS" title={allStrings.afterThreeYears} key="AFTER-THREE-YEARS" />

                                    </TreeSelect>
                                  </MDBCol>
                                  <MDBCol md="6" sm="6">
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.finishingType}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={false}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                      treeCheckable={true}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.finishingType}
                                      value={this.state.finishingType}
                                      disabled={this.state.actionType === "EDIT" ? false : true}
                                      showCheckedStrategy={SHOW_PARENT}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ finishingType: value });
                                      }}
                                    >
                                      <TreeNode value="FULLY-FINISHED" title={allStrings.fullyFinished} key="FULLY-FINISHED" />
                                      <TreeNode value="SEMI-FINISHED" title={allStrings.semiFinished} key="SEMI-FINISHED" />
                                      <TreeNode value="CORE-SHELL" title={allStrings.coreShell} key="CORE-SHELL" />

                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>
                                <MDBRow style={{ flexDirection: this.props.isRTL ? 'row' : 'row-reverse' }}>
                                  
                                  {this.state.priceType === "INSTALLMENT" &&
                                  <MDBCol md="6">
                                    <div className="md-form">
                                      <label htmlFor="form34" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.monthlyInstallment}</label>
                                      <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.monthlyInstallment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} type="text" min={0} id="form34" name="monthlyInstallment" className="form-control" onChange={this.changeHandler} required validate />
                                      <div class="valid-feedback">{allStrings.correct}</div>
                                      <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                    </div>
                                  </MDBCol>
                                  }
                                  <MDBCol md={this.state.priceType === "INSTALLMENT"?"6":"12"}>
                                    <label style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.priceType}</label>
                                    <TreeSelect virtual={false}
                                      showSearch={false}
                                      disabled={this.state.actionType === "EDIT" ? false : true}
                                      style={{ width: '100%', textAlign: this.props.isRTL ? 'right' : 'left', height: '35px', marginBottom: '1rem' }}
                                      treeCheckable={false}
                                      treeNodeFilterProp="title"
                                      dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                      placeholder={allStrings.priceType}
                                      value={this.state.priceType}
                                      showCheckedStrategy={SHOW_PARENT}
                                      onChange={(value) => {
                                        console.log(value)
                                        this.setState({ priceType: value });
                                      }}

                                    >
                                      <TreeNode value="INSTALLMENT" title={allStrings.installment} key="INSTALLMENT" />
                                      <TreeNode value="CASH" title={allStrings.cash} key="CASH" />

                                    </TreeSelect>
                                  </MDBCol>
                                </MDBRow>
                                {this.state.priceType === "INSTALLMENT" &&
                                  <MDBRow>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form323" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.downPayment}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.downPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} type="text" id="form323" name="downPayment" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                    <MDBCol md="6">
                                      <div className="md-form">
                                        <label htmlFor="form324" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.installmentDuration}</label>
                                        <input disabled={this.state.actionType === "VIEW" ? true : false} style={{ direction: this.props.isRTL ? 'rtl' : 'ltr', backgroundPosition: this.props.isRTL ? 'left calc(.375em + .1875rem) center' : 'right calc(.375em + .1875rem) center' }} defaultValue={this.state.installmentDuration} type="number" min={0} id="form324" name="installmentDuration" className="form-control" onChange={this.changeHandler} required validate />
                                        <div class="valid-feedback">{allStrings.correct}</div>
                                        <div class="invalid-feedback">{allStrings.requiredInput}</div>
                                      </div>
                                    </MDBCol>
                                  </MDBRow>
                                }
                                <MDBRow>
                                {this.state.actionType==="EDIT"&&
                                  <MDBCol md="12">
                                    <label htmlFor="form8930" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.companyLogo}</label>

                                    <div className="fileUpload2"> 
                                        <input  key={this.state.companyLogo} type='file' className="upImgs2" onChange={this.fileChangedHandlerCompanyLogo} ></input>
                                        <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.upload}</span></span>
                                    </div>
                                    <div className="preview">
                                    {this.state.companyLogo&&
                                    <div style={{display:"inline-block",width: '100%',border: '1px solid mediumaquamarine'}}>
                                        <img crossorigin="anonymous"alt="" src={this.state.companyLogoType==="data"?URL.createObjectURL(this.state.companyLogo):this.state.companyLogo} className="previewImg2"/>
                                        
                                        <span className="imgName">{this.state.companyLogoName}</span>
                                        <MDBIcon icon="trash" className="mr-2 removeImg3"
                                        onClick={() => this.removeFileCompanyLogo()}  ></MDBIcon>
                                    </div>
                                    }
                                    </div>
                                  </MDBCol>                      
                                }
                                  <br></br>
                                  {this.state.actionType === "EDIT" &&
                                    <MDBCol md="12">
                                      <label for="form830" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.voiceNote}</label>
                                      <div className="fileUpload2">
                                        <input key={this.state.voiceNote} type='file' className="upImgs2" onChange={this.fileChangedHandlerVoiceNote} ></input>
                                        <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.uploadFile}</span></span>
                                      </div>
                                      {this.state.voiceNote != null &&
                                        <div className="preview">
                                          <audio controls className="audioPlayer" id="audioPlayer">
                                            <source id="audioSource" src={this.state.voiceNoteType === "data" ? URL.createObjectURL(this.state.voiceNote) : this.state.voiceNote} type="audio/mpeg" />
                                            <source src={this.state.voiceNoteType === "data" ? URL.createObjectURL(this.state.voiceNote) : this.state.voiceNote} type="audio/ogg"></source>
                                            Your browser does not support the audio element.
                                          </audio>
                                          <MDBIcon icon="trash" className="mr-2 removeImg2" style={{ top: '20px' }}
                                            onClick={() => this.removeFileVoiceNote()}></MDBIcon>
                                        </div>
                                      }
                                    </MDBCol>
                                  }
                                  <br></br>
                                  {this.state.voiceNote != null && this.state.actionType === "VIEW" &&
                                    <MDBCol md="12">
                                      <div style={{ width: '100%' }}>
                                        <label for="form830" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.voiceNote}</label>

                                        <audio controls className="audioPlayerView">
                                          <source src={this.state.voiceNote} type="audio/mpeg" />
                                          <source src={this.state.voiceNote} type="audio/ogg"></source>
                                          Your browser does not support the audio element.
                                        </audio>
                                      </div>
                                    </MDBCol>
                                  }
                                </MDBRow>

                                <br></br>
                                {this.state.actionType === "EDIT" &&
                                  <MDBRow>
                                    <MDBCol md="12">
                                      <label htmlFor="form8930" style={{ textAlign: this.props.isRTL ? 'right' : 'left', width: '100%' }}>{allStrings.imgs}</label>

                                      <div className="fileUpload2">
                                        <input multiple key={this.state.imgs} type='file' className="upImgs2" onChange={this.fileChangedHandler} ></input>
                                        <span className="uploadParent"><UploadOutlined style={{ color: '#000', fontSize: '14px', position: 'relative', top: '-3px', marginRight: '2px' }} /><span className="uploadName">{allStrings.upload}</span></span>
                                      </div>
                                      <div className="preview">
                                        {this.state.imgsPreviewUrl.map((val, i) => (
                                          <div style={{ display: "inline-block", width: '100%', border: '1px solid mediumaquamarine', marginBottom: '10px' }}>
                                            <img crossorigin="anonymous" alt="" src={this.state.imgsType === "data" ? URL.createObjectURL(this.state.imgs[i]) : this.state.imgs[i]} className="previewImg2" />
                                            <span className="imgName">{this.state.imgsName[i]}</span>
                                            <MDBIcon icon="trash" className="mr-2 removeImg2"
                                              onClick={() => this.removeFile(val)}  ></MDBIcon>
                                          </div>
                                        ))}
                                      </div>

                                    </MDBCol>
                                  </MDBRow>
                                }
                                <MDBRow>
                                  {this.state.actionType === "EDIT" &&
                                    <MDBCol md="12">
                                    <label for="form830" style={{textAlign:this.props.isRTL?'right':'left',width:'100%'}}>{allStrings.files}</label>
                                        <div className="fileUpload2"> 
                                            <input  key={this.state.pdf} type='file' className="upImgs2" onChange={this.fileChangedHandlerPdf} ></input>
                                            <span className="uploadParent"><UploadOutlined style={{color: '#000',fontSize: '14px',position: 'relative',top: '-3px',marginRight: '2px'}}/><span className="uploadName">{allStrings.uploadFile}</span></span>
                                        </div>
                                        <div className="preview">
                                            {this.state.pdfName&&
                                            <div style={{ display: "inline-block" }}>
                                            <p className="previewPdf">{this.state.pdfName}
                                            <MDBIcon icon="times" className="mr-2 removePdf"
                                                onClick={() => this.removePdf()}  ></MDBIcon>
                                            </p>
                                            </div>
                                            }
                                        </div>
                                    </MDBCol>
                                  }
                                  <br></br>
                                  {this.state.pdf != null &&
                                      <div>
                                          <a href={this.state.pdf} target="blank" style={{background:'linear-gradient(135deg, #0F1A2C, #233B5B, #3A5278)',
                                          color: '#fff',
                                          padding: '3px 40px',
                                          marginLeft: '15px'}}
                                          >
                                              {allStrings.openFile}          
                                          </a>
                                      </div>
                                  }
                                </MDBRow>
                              </div>
                              <br></br>
                              <br></br>
                              <div className="text-center">
                                {this.state.actionType === "EDIT" &&
                                  <MDBBtn
                                    style={{ background: '#233b5b', color: '#fff' }}
                                    rounded
                                    type="submit"
                                    className="btn-block z-depth-1a"
                                  >
                                    <MDBIcon icon="edit" className="mr-2" />
                                    {allStrings.update}
                                  </MDBBtn>
                                }{this.state.actionType === "VIEW" &&
                                  <Tooltip title={allStrings.areYouSureDelete} placement="top" arrow>
                                    <Popconfirm okText={allStrings.yes} cancelText={allStrings.no}
                                      onConfirm={() => {
                                        this.delete()
                                      }}>
                                      <MDBBtn
                                        color="red"
                                        rounded
                                        style={{ borderRadius: "2px", background: 'red' }}
                                        className="btn-block z-depth-1a"
                                      >

                                        <MDBIcon icon="trash-alt" className="mr-2" />
                                        {allStrings.remove}
                                      </MDBBtn>
                                    </Popconfirm>
                                  </Tooltip>
                                }
                                {this.state.actionType === "VIEW" &&
                                    <MDBBtn
                                    onClick={() => { this.available(this.state.available?false:true) }}
                                    rounded
                                    color={this.state.available?"warning":"info"}
                                    className="btn-block z-depth-1a">
                                    {this.state.available?allStrings.hideInApp:allStrings.showInApp}
                                    </MDBBtn>
                                }

                              </div>
                            </form>
                          </MDBCol>

                        </MDBRow>
                      </MDBContainer>
                    </CardContent>
                  </Card>
                </div>
              </MDBCol>
              {this.state.actionType === "VIEW" && this.imageSection()}
            </MDBRow>

          </MDBContainer>
        </Spin>
      </div>
    )
  }
}



const mapToStateProps = (state) => ({
  isRTL: state.lang.isRTL,
  currentUser: state.auth.currentUser,
});

const mapDispatchToProps = {
};

export default withRouter(
  connect(mapToStateProps, mapDispatchToProps)(sharedPropertyInfo)
);